// extracted by mini-css-extract-plugin
module.exports = {"auth-main":"Authentication-module__auth-main___vAlNS"};